export default "__VITE_ASSET__8dbce960__"